import { useCallback } from "react";
import { Badge, Button, Group } from "@mantine/core";

import { useCompleteTcPathologistReview } from "../../hooks/useWorkflows";

interface TcReviewCompletionButtonProps {
  caseId: string;
  assignmentRevision: number;
  canComplete?: boolean;
}

export function TcReviewCompletionButton({
  caseId,
  assignmentRevision,
  canComplete = true,
}: TcReviewCompletionButtonProps) {
  const completion = useCompleteTcPathologistReview();
  const handleComplete = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      completion.mutate({
        caseId,
        expectedAssignmentRevision: assignmentRevision,
      });
    },
    [assignmentRevision, caseId, completion]
  );

  return (
    <Group gap={6} wrap="nowrap" mt={4}>
      <Badge size="xs" color="yellow" variant="filled">
        TC · action required
      </Badge>
      {canComplete && (
        <Button
          size="compact-xs"
          color="teal"
          onClick={handleComplete}
          loading={completion.isPending}
        >
          Completed
        </Button>
      )}
    </Group>
  );
}
